// extracted by mini-css-extract-plugin
module.exports = {"phase-body":"phase-body__xy4qz"};